import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { useTranslation } from 'react-i18next';

interface CustomerCardProps {
  user: GatewayUserModel;
}

export const CustomerCard = ({
  user,
}: CustomerCardProps): React.JSX.Element => {
  const { t } = useTranslation();
  return (
    <Card flex={1} gap={GapEnum.M}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={user.customer ? 'space-between' : 'flex-start'}>
        <AccentTitle
          icon="dataflow-04"
          as={HeadingEnum.H2}
          text={t('delmonicos-shared-sdk.outputs-user.customer')}
          variant={AccentVariantEnum.Secondary}
        />
        {user.customer && (
          <Text
            fontSize={TextFontSize.Medium}
            color={TextColor.Secondary}
            italic>
            {user.customer.name}
          </Text>
        )}
      </Stack>
      <Divider />
      <Stack justifyContent="space-between">
        <Text bold>
          <Icon name="user-admin" />
          {t('delmonicos-shared-sdk.outputs-user.role')}
        </Text>
        <Text>{user.roles?.map((r) => r.name).join(', ')}</Text>
      </Stack>
    </Card>
  );
};
